import { SITE_TOKEN_COOKIE, CACHE_BUSTER_COOKIE } from 'Utils/constants';
import Cookies from 'js-cookie';

class CustomError extends Error {
  constructor(name, message) {
    super(message);
    this.name = name || 'Error';
  }
}

async function refreshJWT(expired_token) {
  if(typeof ewiSettings === 'undefined') {
    var ewiSettings = {
      root: '',
    }
  }

  try {
    console.log('Trying to refresh...');
    const response = await fetch(`${ewiSettings.root}/wp-json/MasterTheme/v1/refreshJWT/${expired_token}`);
    if(response?.ok) {
      const newToken = await response.json();
 
      Cookies.set(SITE_TOKEN_COOKIE, newToken);
      return true;
    }
  } catch(error) {
    throw new Error(`${error.code} - ${error.message}.`);
  }
}

/**
 * A wrapper function around fetch that allows the refreshing of a token if it has expired
 * @param {*} url
 * @param {*} options 
 * @returns HTTP Response
 */
async function fetchWithJWT(url, options) {
  console.log('Attempting normal fetch...', url, options);
  const response = await fetch(url, options);
  
  // If token verification is successful, return with the original fetch request
  if(response?.ok) {
    Cookies.remove(CACHE_BUSTER_COOKIE); // Ensure cache buster cookie is removed if it was present on successful response
    return response;
  } else {
    // If the toke has expired then we attempt to refresh the token
    const error = await response.json();
    console.log('Error in JWT Fetch', error);
    if(error.message === 'Expired token') {
      const refreshResponse = await refreshJWT(error.data.expired);

      if(refreshResponse) {
        // Attempt a 2nd try on the original fetch call using a refresh valid token
        try {
          const response2 = await fetch(url, options);

          if(response2?.ok) {
            return response2;
          } else {
            throw new CustomError('Auth Error 1', 'Failed to refresh token. Please restart your session.');
          }
        } catch(error) {
          throw new CustomError('Auth Error 2', `${error.code} - ${error.message}.`);
        }
      }
    } else if (error.message === 'Signature verification failed') {
      const removeCookieAndBustCache = new Promise((resolve, reject) => {
        const token = Cookies.get(SITE_TOKEN_COOKIE);
        if(token) {
          Cookies.remove(SITE_TOKEN_COOKIE);
          Cookies.set(CACHE_BUSTER_COOKIE, true); // If we need to reload the page make sure to bust cache to prevent reload loop
          setTimeout(() => {
            resolve(true);
          }, 500);
        } else {
          reject('false');
        }
      });

      console.error(`${error.code} - ${error.message}`);

      console.warn('Reloading page for new token...');
      removeCookieAndBustCache.then(() => {
        window.location.reload();
      });
      
      throw new CustomError('Auth Error 3', `${error.code} - ${error.message}`);
    } else {
      throw new CustomError('Error', `${error.code} - ${error.message}`);
    }
  }
}

export { CustomError, fetchWithJWT }